import { MuiCheckbox } from '@apeiron/ui'
import { Box, FormControlLabel, FormGroup, styled } from '@mui/material'
import { FilterTitle } from '@src/components/share/filter/FilterSection'
import { ChangeEvent, useCallback } from 'react'

const CheckboxGroup = styled(FormGroup)`
  justify-content: flex-start;
  align-items: flex-start;
`

const CheckboxGroupLabel = styled(FilterTitle)`
  font-size: 16px;
  line-height: 18px;
  color: #333333;
`

const CheckboxLabel = styled(FormControlLabel)`
  & .MuiFormControlLabel-label {
    font-size: 16px;
    font-weight: 400;
    line-height: 16px;
    color: #333333;
  }

  margin: 0px;
  white-space: nowrap;
`

const StyledCheckboxLabel = styled(CheckboxLabel)`
  min-width: 120px;
  flex: 1;
`

const StyledCheckbox = styled(MuiCheckbox)`
  padding-left: 0px;

  .MuiCheckbox-root {
    color: #333333;
  }
`

export const FilterCheckboxGroup = <T extends unknown>(props: Props<T>) => {
  const { className, label, items, onChange, value } = props

  const onCheckboxChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>, checked: boolean) => {
      const itemValue = items.find(
        item => item.name === event.target.name
      )?.value

      if (itemValue === undefined) return

      let newValue = [...value]

      if (checked) {
        !newValue.includes(itemValue) && newValue.push(itemValue)
      } else {
        newValue = newValue.filter(value => value !== itemValue)
      }

      onChange?.(newValue)
    },
    [items, onChange, value]
  )

  return (
    <Box className={className}>
      <CheckboxGroupLabel>{label}</CheckboxGroupLabel>
      <CheckboxGroup row>
        {items.map(item => (
          <StyledCheckboxLabel
            key={item.name}
            control={
              <StyledCheckbox
                checked={value.includes(item.value)}
                onChange={onCheckboxChange}
                name={item.name}
              />
            }
            label={item.label}
          />
        ))}
      </CheckboxGroup>
    </Box>
  )
}

export type FilterCheckboxItem<T> = {
  name: string
  label: string
  value: T
}

type Props<T> = {
  className?: string
  label: string
  items: FilterCheckboxItem<T>[]
  value: T[]
  onChange?: (value: T[]) => void
}
